module.exports = __webpack_public_path__ + "img/img-classify4.81eec5bf.png";